import { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Divider,
  Modal,
  Pagination,
  Typography,
} from '@mui/material';
import { ENV, STRINGS } from '../../constants';
import { getImageUrl } from '../../utils/images';
import useBreakpoint from '../../hooks/useBreakpoint';

const GalleryWidget = ({ images, parcelNumber, isOpen, onClose, title }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const isSmallScreen = useBreakpoint('sm');

  return (
    <Modal open={isOpen}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          bgcolor: 'primary.contrastText',
          m: { xs: '20% auto', md: '10% auto' },
          borderRadius: 1,
          maxWidth: { xs: '95%', md: '550px' },
          height: '60vh',
          overflowY: {
            xs: 'scroll',
            sm: 'auto',
          },
          position: 'relative',
        }}
      >
        <Typography variant='h3' sx={{ p: 2 }}>
          {title}
        </Typography>
        <Divider />
        <Box sx={{ p: 2, height: 'calc(100% - 110px)' }}>
          <Box
            component='img'
            width='100%'
            height='100%'
            src={getImageUrl({ ...images[currentImageIndex], parcelNumber })}
            onError={e =>
              (e.target.src = `${ENV.CDN_BASE_URL_IMAGES}/image-not-found.png`)
            }
            sx={{ borderRadius: 1, objectFit: 'contain' }}
          />

          <Box sx={{ display: 'flex', justifyContent: 'center', p: 1 }}>
            <Pagination
              page={currentImageIndex + 1}
              count={images.length}
              showFirstButton={!isSmallScreen}
              showLastButton={!isSmallScreen}
              onChange={(_, imageIndex) => {
                setCurrentImageIndex(imageIndex - 1);
              }}
            />
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row-reverse',
            paddingX: 2,
            pb: 2,
          }}
        >
          <Button onClick={onClose} variant='contained' color='primary'>
            {STRINGS.CLOSE}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

GalleryWidget.propTypes = {
  title: PropTypes.string,
  parcelNumber: PropTypes.string,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      imageKey: PropTypes.string,
      imageType: PropTypes.string,
      imageCaption: PropTypes.string,
    })
  ),
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
};

export default GalleryWidget;
